import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { thermometerHeight } from "./thermometerStyles";

export const prepFqReportStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
    },
    loaderRoot: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: 400,
      marginBottom: 64,
      width: "100%",
    },
    pageTitle: {
      color: "#002655",
      fontStyle: "italic",
      fontSize: "48px",
      marginBottom: "12px",
      textAlign: "center",
      marginTop: 0,
      zIndex: 10,
      "@media (max-width: 960px)": {
        paddingLeft: "12px",
        paddingRight: "12px",
        marginTop: 24,
      },
    },
    blueText: {
      color: "#5db2e3 !important",
    },
    helpIcon: {
      color: "#002655",
      cursor: "pointer",
      fontSize: "36px",
      "@media (max-width: 960px)": {
        display: "none",
      },
    },
    prioritiesBackgroundRoot: {
      position: "relative",
    },
    prioritiesBackground: {
      background:
        "linear-gradient(180deg, rgba(242,246,247,0) 0%, rgba(204,217,221,1) 100%)",
      margin: "-265px auto 0 auto",
      padding: "265px 0 0 0",
      minHeight: 750,
      position: "absolute",
      zIndex: -8,
      width: "100%",
      height: "100%",
      // transition: "all 0.3s",
      "@media (max-width: 1200px)": {
        height: "calc(100% + 160px)",
      },
    },
    prioritiesForeground: {
      backgroundColor: "#E6ECEE",
      height: "30%",
      zIndex: 1,
      position: "absolute",
      width: "100%",
      bottom: 0,
    },
    prioritiesTitleLarge: {
      color: "#002655",
      fontStyle: "italic",
      fontWeight: "bold",
      fontSize: "32px",
      marginBottom: "12px",
      marginTop: "32px",
      textAlign: "center",
      width: "100%",
      position: "relative",
      "@media (max-width: 960px)": {
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    prioritiesTitle: {
      color: "#002655",
      fontStyle: "italic",
      fontWeight: "bold",
      fontSize: "20px",
      marginBottom: "18px",
      marginTop: "32px",
      textAlign: "center",
      width: "100%",
      position: "relative",
      "@media (max-width: 960px)": {
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    pickPrioritiesButton: {
      textTransform: "uppercase !important" as any,
    },
    enhanceBackButton: {
      position: "absolute !important" as any,
      left: 64,
      fontSize: "18px !important",
      "@media (max-width: 960px)": {
        paddingLeft: "12px !important",
        paddingRight: "12px !important",
        position: "relative !important",
        left: 0,
      },
    },
    settingsButton: {
      position: "absolute !important" as any,
      right: 64,
      fontSize: "18px !important",
      "@media (max-width: 960px)": {
        paddingLeft: "12px !important",
        paddingRight: "12px !important",
        position: "relative !important",
        right: 0,
      },
    },
    settingsButtonAlt: {
      fontSize: "18px !important",
      "@media (max-width: 960px)": {
        paddingLeft: "12px !important",
        paddingRight: "12px !important",
        position: "relative !important",
        right: 0,
      },
    },
    prioritiesContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      margin: "36px",
      minHeight: "300px",
      "@media (max-width: 960px)": {
        paddingLeft: "12px",
        paddingRight: "12px",
        flexDirection: "column",
      },
    },
    priorityCard: {
      borderRadius: "35px !important",
      minHeight: "300px",
      minWidth: "275px",
      margin: "0px 12px",
      // boxShadow: "5px 5px 5px rgba(0,0,0,0.4) !important",
      border: "1px solid rgba(0,0,0,0.4)",
      "@media (min-width: 960px) and (max-width: 1060px)": {
        margin: "0px 24px",
      },
      "@media (max-width: 960px)": {
        margin: "12px 12px",
      },
    },
    priorityCardHeader: {
      backgroundColor: "#002655",
      height: "75px",
    },
    priorityCardTitle: {
      color: "white",
      textAlign: "center",
      fontWeight: 600,
      fontSize: 20,
    },
    priorityCardContent: {
      padding: "0 !important",
    },
    priorityProgressContainer: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      flexDirection: "row",
      width: "100%",
    },
    priorityProgress: {
      borderBottom: "solid 1px #3E4066",
      borderRight: "solid 1px #3E4066",
      borderBottomRightRadius: "24px",
      padding: "6px 12px 6px 12px",
      width: 85,
    },
    priorityProgressText: {
      color: "#3E4066",
      fontWeight: 600,
      fontSize: "24px",
      textAlign: "center",
      position: "relative",
      marginRight: 0,
      marginBottom: 0,
    },
    percentage: {
      position: "absolute",
      fontSize: "16px",
      left: 48,
      top: 0,
    },
    priorityIconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "12px",
      height: 120,
    },
    priorityIcon: {
      fontSize: "72px !important",
      color: "#3E4066",
    },
    priorityActions: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
    priorityActionButton: {
      fontWeight: "600 !important" as any,
      fontSize: "16px !important",
    },
    borderedCard: {
      borderRadius: "35px !important",
      borderColor: "#CCD9DD",
      borderWidth: "5px",
      borderStyle: "solid",
      padding: "24px 48px",
      width: "100%",
      marginBottom: "72px",
      position: "relative",
      transition: "margin 0.3s",
      "@media (max-width: 960px)": {
        padding: "12px 24px",
      },
    },
    thermometerCard: {
      "@media (max-width: 960px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    reverseColumn: {
      "@media (max-width: 960px)": {
        flexDirection: "column-reverse !important",
      },
    },
    thermometerColumn: {
      // height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "column",
      width: "100%",
    },
    scoreContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      width: "100%",
      "@media (max-width: 960px)": {
        width: "unset",
      },
    },
    scaledScore: {
      color: "#3E4066",
      fontSize: "72px",
      textAlign: "center",
      fontWeight: 900,
      position: "relative",
      marginRight: 32,
      lineHeight: 1,
    },
    scaledScoreTotal: {
      position: "absolute",
      fontSize: "32px",
      fontWeight: 300,
      top: 12,
    },
    suggestionsList: {
      listStyle: "none",
      "@media (max-width: 960px)": {
        padding: 0,
      },
    },
    suggestionsListItem: {
      listStyle: "none",
    },
    suggestionsListItemAlt: {
      listStyle: "none",
      marginBottom: 12,
    },
    suggestionsListItemText: {
      fontSize: "16px",
      lineHeight: 1.8,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      flexDirection: "row",
      position: "relative",
      transition: "0.3s ease-in-out",
    },
    suggestionsListItemTextAfter: {
      cursor: "pointer",
      "&:after": {
        content: '""',
        position: "absolute",
        height: 0,
        maxWidth: 300,
        width: 0,
        left: 24,
        bottom: 0,
        borderBottom: "2px solid #002655",
        transition: "0.5s ease-in-out",
      },
      "&:hover": {
        "&:after": {
          width: "100%",
        },
      },
    },
    suggestionsListItemTextAfterAlt: {
      "&:after": {
        left: 0,
      },
    },
    promptText: {
      fontSize: "16px",
      lineHeight: 1.8,
      display: "flex",
    },
    promptContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },
    suggestionsTitle: {
      color: "#3E4066",
      fontSize: "20px",
      marginBottom: "24px",
      marginTop: 36,
      fontWeight: 600,
    },
    suggestionIconContainer: {
      position: "absolute",
      left: 48,
      top: -43,
      zIndex: 2,
      // backgroundColor: "white",
    },
    suggestionIconContainerLarge: {
      position: "absolute",
      left: 48,
      top: -60,
      zIndex: 2,
      // backgroundColor: "white",
    },
    suggestionIconSize: {
      fontSize: "86px !important",
      maxWidth: "86px !important",
      maxHeight: "86px !important",
    },
    suggestionIconLarge: {
      fontSize: "120px !important",
      maxWidth: "120px !important",
      maxHeight: "120px !important",
    },
    lotsIcon: {
      color: "#3E4066 !important",
    },
    littleIcon: {
      color: "#3E4066 !important",
    },
    wellIcon: {
      color: "#5db2e3 !important",
    },
    helpTextTop: {
      fontSize: "16px",
      marginLeft: "164px",
      marginBottom: "8px",
    },
    helpTextBottom: {
      fontSize: "16px",
      marginLeft: "96px",
      marginTop: "8px",
      "@media (max-width: 960px)": {
        marginLeft: "16px",
        marginBottom: "32px",
      },
    },
    scoresRoot: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "column",
      minHeight: thermometerHeight,
      marginLeft: "36px",
      "@media (max-width: 960px)": {
        width: "unset",
      },
    },
    scoresColumn: {
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      flexDirection: "column",
    },
    scoreRating: {
      fontSize: 24,
      marginBottom: 0,
    },
    historyLink: {
      fontSize: 18,
      marginBottom: 48,
      color: "#5db2e3",
      textDecoration: "underline",
      textAlign: "center",
    },
    avgScoresContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      width: "100%",
      marginBottom: "12px",
      maxWidth: 200,
    },
    avgScoresTextContainer: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      flexDirection: "column",
      width: "100%",
    },
    avgScoresText: {
      color: "#3E4066",
      fontSize: "16px",
      marginBottom: 0,
    },
    avgScore: {
      color: "#3E4066",
      fontSize: "18px",
      fontWeight: 600,
    },
    shareContainer: {
      marginBottom: "16px",
      width: "100%",
    },
    thermometerTitle: {
      color: "#002655",
      fontSize: 32,
      textTransform: "uppercase",
      textAlign: "center",
      lineHeight: 1.9,
      marginBottom: 48,
    },
    downloadButton: {
      backgroundColor: "#F2F4F3 !important",
      color: "#18223C !important",
      minHeight: 50,
      fontSize: "16px !important",
    },
    downloadIcon: {
      color: "#18223C !important",
    },
    goButtonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      marginTop: 12,
      marginBottom: 18,
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      zIndex: 2,
      position: "relative",
      minHeight: 400,
    },
    footerImage: {
      minHeight: 1030,
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundImage: `url('/map.jpg')`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      margin: "-96px auto -630px auto",
      padding: "96px 0 630px 0",
      position: "absolute",
      zIndex: -12,
    },
    footerOpacity: {
      minHeight: 1030,
      opacity: 0.7,
      backgroundColor: "white",
      height: "100%",
      width: "100%",
      position: "absolute",
      margin: "-96px auto -630px auto",
      padding: "96px 0 630px 0",
      zIndex: -10,
    },
    footerContents: {
      width: "100%",
      height: "100%",
      paddingTop: 96,
      paddingBottom: 48,
    },
    footerGrid: {
      margin: "0 auto",
      maxWidth: 1200,
      "@media (max-width: 960px)": {
        flexDirection: "column-reverse",
      },
    },
    footerGridItem: {
      padding: 24,
    },
    footerImageContainer: {},
    footerTitle: {
      color: "#002655",
      fontStyle: "italic",
      fontSize: 42,
      marginBottom: "12px",
    },
    footerDescription: {
      fontSize: 16,
      lineHeight: 1.8,
      color: "#3E4066",
    },
    backButtonContainer: {
      marginBottom: 40,
      marginTop: 40,
    },
    backButton: {
      fontSize: 20,
      marginLeft: 24,
      textTransform: "capitalize",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    borderedCardAlt: {
      backgroundColor: "rgb(227, 235, 235)",
      minHeight: 350,
      width: "100%",
      "@media (max-width: 600px)": {
        minHeight: 300,
      },
    },
    goButtonContainerAlt: {
      justifyContent: "flex-start",
      marginTop: 24,
      height: "100%",
    },
    spaceBetweenBox: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      height: "100%",
      minHeight: 286,
      "@media (max-width: 600px)": {
        minHeight: 250,
      },
    },
    rightCol: {
      marginLeft: 32,
      "@media (max-width: 960px)": {
        marginLeft: 0,
      },
    },
    backBtnContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      fontSize: 16,
      cursor: "pointer",
      maxWidth: 100,
      marginBottom: 24,
    },
  })
);
